import { IAgencyWelcomeFormFields } from './AgencyWelcomeForm.interfaces';

const AGENCY_WELCOME_FORM_INITIAL_VALUES: IAgencyWelcomeFormFields = {
  organisation: '',
  project: '',
};

export { AGENCY_WELCOME_FORM_INITIAL_VALUES };
